<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
    effect: SkillEffect;
}>();

const effectTypes = {
    "1": "ATK",
    "2": "DEF",
    "3": "ATK & DEF",
    "9": "Stun",
    "24": "Disable Guard",
    "48": "Seal Super Attack",
    "76": "Effective vs. All",
    "84": "HP",
    "90": "Critical Hit",
    "111": "Disable Action",
};

const effectTargets = {
    "1": "self",
    "2": "team",
    "3": "enemy",
    "4": "enemy team",
    "12": "super allies",
    "13": "extreme allies",
    "14": "super enemies",
    "15": "extreme enemies",
    "16": "team (excl. self)",
};

const effectCalculations = {
    "0": "+",
    "2": "+",
    "3": "-",
};

const formatted = computed<string>(() => {
    const chance = `${
        props.effect.chance > 0 && props.effect.chance < 100
            ? `${props.effect.chance}% chance of `
            : ""
    }`;

    const values = props.effect.values.filter((v) => v !== 0).join("/");

    const calculation =
        values !== ""
            ? `${effectCalculations[props.effect.calculation]}${values}${
                  props.effect.calculation !== 0 ? "%" : ""
              }`
            : "";

    const turns =
        props.effect.type !== 84 && props.effect.turns > 0
            ? ` for ${props.effect.turns} turn${
                  props.effect.turns === 1 ? "" : "s"
              }`
            : "";

    return `${chance}${effectTypes[props.effect.type]} (${
        effectTargets[props.effect.target]
    }) ${calculation}${turns}`;
});
</script>

<template>
    <span>{{ formatted }}</span>
</template>
<style scoped></style>
